// The menu's name for focus mode `modeId` (e.g. "Proposals Focus"), or null
// for General Focus, which shows no chip anywhere, and for a mode not in
// `modes` (the list GET /focus-modes returns).
export function focusModeDisplayName(modes, modeId) {
  if (!modeId || modeId === 'default') return null;
  return (modes || []).find((mode) => mode.id === modeId)?.name || null;
}

// Whether a conversation's focus mode tag (the API's `focus_mode`) matches a
// lowercased search: its full name ("3190 346 Madison II", "Proposals Focus")
// or its job number ("3190"), so typing either finds the rows with that tag.
export function focusModeTagMatches(focusMode, searchText) {
  if (!focusMode || !searchText) return false;
  return [focusMode.name, focusMode.short]
    .some((text) => typeof text === 'string' && text.toLowerCase().includes(searchText));
}

// A group chat's own focus mode ({id, name}) -- the one KAI answers everyone
// in it in, and the menu shows as active -- or null: not a group chat, one
// the reader has left, or one its first question hasn't set yet.
// `group_focus_mode` is the latest word from a poll or a switch.
export function groupChatFocusMode(conversation) {
  if (!conversation?.is_group || conversation.left_group) return null;
  if (conversation.group_focus_mode?.id) return conversation.group_focus_mode;
  const id = conversation.group?.focus_mode;
  return id ? { id, name: conversation.group.focus_mode_name || id } : null;
}

// The focus modes menu's list (`modes`), plus a group chat's own mode when
// the reader's list hasn't got it: everyone in that chat is answered in it,
// but only there (chat_only).
export function withChatFocusMode(modes, chatMode) {
  const list = modes || [];
  if (!chatMode?.id || list.some((mode) => mode.id === chatMode.id)) return list;
  return [{ id: chatMode.id, name: chatMode.name || chatMode.id, chat_only: true }, ...list];
}
